import * as React from "react";
import { useTranslation } from "react-i18next";

export const OpenOfferButton = ({
  open,
  fetching,
}: {
  open: (() => void) | null;
  fetching: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div className="mt-1">
      {open !== null ? (
        <button
          onClick={open}
          className="px-3 py-1 rounded-lg bg-yellow-400 text-red-800 font-bold text-sm"
        >
          {t("pack_offer.open")}
        </button>
      ) : (
        !fetching && (
          <span className="text-sm text-gray-400">
            {t("pack_offer.not_available")}
          </span>
        )
      )}
    </div>
  );
};
